export const HOME = "/home";

export const WISHLIST = "/wishlist";

export const DASHBOARD = "/dashboard";

export const SIGNUP = "/signup";

export const COURSE_DETAILS = "/course/:id";

export const LESSONS_PLAYER = "/enrolled-course/:id";

export const GAMIFICATION_BOARD = "/gamification-board";

export const DOUBTFOURM = "/doubt-forum";

export const CHECKOUT = "/checkout";

export const SEARCH_SECTION = "/search";

export const DOUBT_QUESTIONS_DETAILS = "/doubt-forum/:id";

export const MENTOR_SECTION = "/mentor/:id";

export const ASK_QUESTION = "/question/aks";

export const CLASSROOM = "/classroom";

export const CATEGORIES = "/categories/:name";

// **************************************************************************

export const CHALLENGES = "/challenges";

export const CHALLENGES_DETAILS = "/challenges/:id";

export const NOTIFICATION = "/notification";

export const ASSIGNMENTS_DETAILS = "/assignments/:id";
